import { createContainer } from 'unstated-next'
import { useState } from 'react'

function useStudent(initialState) {
    const [student, setStudent] = useState(initialState)
    return { student, setStudent }
}

export default createContainer(useStudent)
